import styled from 'styled-components';

export const TertiaryButtonContainer = styled.button`
  text-align: left;
  padding-inline: ${({ theme }) => theme.spacing.m};
  height: 40px;
  max-height: 40px;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
  background: none;
  border: none;

  span {
    display: inline-block; /* Ensures the span's width matches the text content */
    color: ${({ theme }) => theme.colors.grey5};
    font-weight: bold;
    text-overflow: ellipsis;
    text-transform: uppercase;
    letter-spacing: 0.1rem;
    border-bottom: 2px solid ${({ theme }) => theme.colors.orange4};
    transition: border-color 0.3s ease; /* Smooth transition for hover effect */
  }

  &:hover {
    background: none;
    color: ${({ theme }) => theme.colors.grey3};
  }

  span:hover {
    border-bottom: 3px solid ${({ theme }) => theme.colors.yellow4};
  }
`;
